import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
}));

function ResultTable(props) {
  const classes = useStyles();
  return (
    <TableContainer className={classes.root}>
      <Table>
        <caption>Package arrival status is not real-time update information.</caption>
        <TableHead>
          <TableRow>
            <TableCell>Tracking Number</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.searchData.length > 0 ? (
            props.searchData.map(function (a, i) {
              return (
                <TableRow key={i}>
                  <TableCell>{props.searchData[i]["LocalTrackingNumber"]}</TableCell>
                  <TableCell>{props.searchData[i]["Status"]}</TableCell>
                </TableRow>
              );
            })
          ) : (
            <TableRow>
              <TableCell colSpan="2" align="center">
                Please submit local tracking number
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default ResultTable;
